import React from "react";
import { Link } from "react-router-dom";

function Testimonials() {
  return (
    <div className="w-full bg-slate-50/50 font-sans overflow-hidden">

      {/* Premium Hero Section */}
      <div className="relative w-full bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 pt-20 pb-28 md:pt-24 md:pb-36 lg:pt-28 lg:pb-40 px-6 overflow-hidden">

        {/* Ambient Radial Glow Effect */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/10 rounded-full blur-3xl pointer-events-none"></div>

        <div className="max-w-4xl mx-auto text-center text-white space-y-4 relative z-10 flex flex-col items-center">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-2 shadow-sm">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse"></span>
            <span className="text-xs font-bold uppercase tracking-wider text-orange-50">Leadership Message</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight drop-shadow-md">
            From the Desk of the Director
          </h1>

          {/* Glassmorphic Quote Pill */}
          <div className="mt-4 px-6 py-3 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 shadow-lg max-w-xl mx-auto text-orange-50 font-medium italic text-lg sm:text-xl md:text-2xl leading-relaxed">
            <span className="text-2xl font-black leading-none mr-1 select-none">“</span>
            <span>The biggest risk in life is not taking any risk</span>
            <span className="text-2xl font-black leading-none ml-1 select-none">”</span>
          </div>
        </div>

        {/* Clean Solid White Curved SVG Divider */}
        <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-[0] z-10">
          <svg
            className="relative block w-full h-[60px] md:h-[100px]"
            viewBox="0 0 1920 120"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0,120 C640,30 1280,30 1920,120 L1920,120 L0,120 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </div>

      {/* Breadcrumb Navigation Bar */}
      <div className="bg-white py-3.5 px-6 sm:px-12 border-b border-slate-100 relative z-20">
        <div className="max-w-7xl mx-auto flex items-center space-x-2 text-xs sm:text-sm font-medium text-slate-500">
          <Link to="/" className="text-orange-600 hover:text-orange-700 font-semibold transition-colors">Home</Link>
          <span className="text-slate-300 font-light">&gt;</span>
          <span className="text-slate-800">Testimonials</span>
        </div>
      </div>

      {/* Main Narrative Card Container */}
      <section className="py-16 md:py-24 max-w-4xl mx-auto px-6 relative">
        <div className="bg-white rounded-3xl border border-slate-200/80 p-8 sm:p-12 shadow-xl shadow-slate-200/50 relative overflow-hidden space-y-6">
          <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-orange-500 to-amber-500"></div>

          {/* Greeting Block */}
          <div className="text-slate-900 text-base sm:text-lg font-bold tracking-tight text-left border-b border-slate-100 pb-4">
            Dear Valued Customers, Partners, and Stakeholders,
          </div>

          {/* Narrative Text Content */}
          <div className="flex flex-col text-slate-600 text-sm sm:text-base leading-relaxed space-y-4 text-left sm:text-justify font-normal">
            <p>
              I am thrilled to commemorate a remarkable milestone in the journey
              of PoloPipes as we celebrate the 19th anniversary of our company.
              This momentous occasion allows us to reflect on our past
              achievements, acknowledge our growth, and set our sights on an even
              more promising future.
            </p>
            <p>
              Nineteen years ago, we embarked on a mission to revolutionize the
              piping industry with innovation, durability, and reliability at the
              forefront. Our dedication to quality and unwavering commitment to
              meeting the diverse needs of our customers have guided us through
              every step of this extraordinary journey. Today, as I look back, I
              am filled with immense pride and gratitude for your trust in us.
            </p>
            <p>
              PoloPipes stands as a testament to our unrelenting pursuit of
              excellence. Its cutting-edge design, advanced materials, and
              meticulous craftsmanship have seamlessly met the demands of
              countless projects across various sectors. From plumbing to
              construction, agriculture to infrastructure development, our plastic
              pipes have played an indispensable role in modern living.
            </p>
            <p>
              Our success story wouldn't have been possible without the continuous
              support of our dedicated employees, loyal customers, and
              collaborative partners. Your insights, feedback, and shared vision
              have propelled us to push the boundaries of innovation, enabling us
              to deliver solutions that meet industry standards and exceed
              expectations.
            </p>
            <p>
              Looking forward, we remain firmly committed to pushing the envelope
              even further. Our research and development teams continue to explore
              new materials, manufacturing techniques, and eco-friendly practices
              to ensure that even more ground-breaking advancements mark the next
              decades.
            </p>
            <p>
              As we celebrate this milestone, let us reflect on our achievements
              and embrace the opportunities that lie ahead. Together, we can
              continue to shape the future of the piping industry and contribute
              to a world built on strength, sustainability, and progress.
            </p>

            <div className="p-4 rounded-2xl bg-orange-50/60 border border-orange-100 mt-2">
              <p className="text-slate-800 font-semibold text-xs sm:text-sm">
                Thank you for being an integral part of our journey. Here's to 19
                years of innovation, resilience, and excellence with PoloPipes.
              </p>
            </div>
          </div>

          {/* Signature Line */}
          <div className="flex flex-col pt-6 border-t border-slate-100 text-left">
            <h2 className="text-xl font-extrabold text-slate-900 tracking-tight">
              Sanjay Kumar
            </h2>
            <span className="text-xs sm:text-sm font-semibold text-orange-600">
              Director, PoloPipes
            </span>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Testimonials;